<template>
    <div class="copy-container">
      <p id="content-to-copy">
        This is the content you can copy to the clipboard by clicking the button below.
      </p>
      <button @click="copyToClipboard" class="copy-button">
        Copy to Clipboard
      </button>
      <p v-if="copied" class="copy-success">Content copied to clipboard!</p>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        copied: false,
      };
    },
    methods: {
      copyToClipboard() {
        // Get the content of the element
        const content = document.getElementById("content-to-copy").textContent;
  
        // Copy to clipboard
        navigator.clipboard
          .writeText(content)
          .then(() => {
            this.copied = true; // Show success message
            setTimeout(() => {
              this.copied = false; // Hide the message after 2 seconds
            }, 2000);
          })
          .catch((err) => {
            console.error("Failed to copy: ", err);
          });
      },
    },
  };
  </script>
  
  <style scoped>
  .copy-container {
    font-family: Arial, sans-serif;
    text-align: center;
    margin: 20px auto;
    max-width: 400px;
  }
  
  #content-to-copy {
    background-color: #f4f4f4;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    margin-bottom: 15px;
  }
  
  .copy-button {
    background-color: #4caf50;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 16px;
  }
  
  .copy-button:hover {
    background-color: #45a049;
  }
  
  .copy-success {
    color: #4caf50;
    font-size: 14px;
    margin-top: 10px;
  }
  </style>
  